import { Component, Input } from '@angular/core';
import { ThingAlarmsInterface } from '@app/app/shared/interfaces/thing/thing-alarms.interface';

@Component({
  templateUrl: './park-alarms.html',
  selector: 'park-alarms'
})
export class ParkAlarmsComponent {
  @Input() alarms: ThingAlarmsInterface[];

  public filters: [{ value: string, label: string }] = [
    {value: 'Pending', label: 'Pending'},
    {value: 'Solved', label: 'Solved'},
    {value: 'All', label: 'All'},
  ];

  public selectedFilter: string = null;

  public sortedAlarms() {
    if (this.selectedFilter !== 'All' && this.selectedFilter !== null) {
      const filteredAlarms = [];
      for (const alarm of this.alarms) {
        if (alarm.status === this.selectedFilter.toLowerCase()) {
          filteredAlarms.push(alarm);
        }
      }
      return filteredAlarms;
    }

    return this.alarms.sort((a, b) => {
      if (a.timestamp > b.timestamp) {
        if (a.status === 'pending') {
          return -1;
        }
      }

      if (a.timestamp < b.timestamp) {
        if (b.status === 'pending') {
          return 1;
        }
      }

      return 0;
    });
  }

  public setFilter($event: any) {
    this.selectedFilter = $event.target.value;
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/alarms/park-alarms.component.ts